module.exports = __webpack_public_path__ + "img/icon.bafc1346.svg";